module.exports = __webpack_public_path__ + "components/resort-guide/static/icon-ski-lift--black-47723717d21d12ebd4349845396edf5b.svg";